import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_ctx.data)
    ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        class: "spin-fullscreen",
        tip: _ctx.tipTxt
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_alert, {
            message: "Alert message title",
            description: "Further details about the context of this alert."
          })
        ]),
        _: 1
      }, 8, ["tip"]))
    : _createCommentVNode("", true)
}